// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import "@hotwired/turbo-rails"
import Rails from "@rails/ujs"
import * as ActiveStorage from "@rails/activestorage"
import "channels"
import jQuery from "jquery"
import "chartkick/chart.js"

// Expose jQuery globally for inline scripts
window.$ = window.jQuery = jQuery

Rails.start()

// React components
import React from 'react'
import { render } from "react-dom"
import App from "../components/App"

ActiveStorage.start()

document.addEventListener('DOMContentLoaded', () => {
  render(<App />, document.body.appendChild(document.createElement("div")))
})
